// File: src/StatusPage.jsx

import React from 'react';
import { Box, Typography, Button, Paper } from '@mui/material';
import {
    MdBuild,        // Icon for Maintenance/Improvement
    MdErrorOutline, // Icon for 404/Error
    MdHome,         // Icon for navigating home
} from 'react-icons/md';
import { Link } from 'react-router-dom';

// --- Styling Constants (These should match your dashboard theme) ---
const BRAND_ACCENT = "#10b981"; 
const TEXT_COLOR = "#374151"; 
const TOPBAR_HEIGHT = 64; 

/**
 * StatusPage Component
 * Displays a professional status page (404, Maintenance, etc.)
 */
const StatusPage = ({
    title = "Page Under Improvement",
    message = "The page you requested is currently undergoing maintenance or does not exist. Please navigate back to the dashboard.",
    type = 'maintenance',
    redirectTo = '/dashboard'
}) => {

    // Choose icon based on the type prop
    const IconComponent = type === '404' ? MdErrorOutline : MdBuild;

    return (
        <Box
            sx={{
                width: '100%',
                height: `calc(100vh - ${TOPBAR_HEIGHT}px)`, // FIXED HEIGHT
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                backgroundColor: '#f9fafb',

                // 🔒 Prevent unwanted scrollbars
                overflow: 'hidden',
                boxSizing: 'border-box',
            }}
        >
            <Paper 
                elevation={3}
                sx={{ 
                    p: { xs: 3, md: 6 },
                    maxWidth: 600,
                    width: '100%',
                    textAlign: 'center',
                    borderRadius: 4,
                    bgcolor: '#fff',
                }}
            >
                {/* Icon */}
                <IconComponent 
                    size={64} 
                    style={{ 
                        color: BRAND_ACCENT, 
                        marginBottom: 16 
                    }} 
                />

                {/* Title */}
                <Typography 
                    variant="h4"
                    component="h1"
                    sx={{ 
                        fontWeight: 700,
                        color: TEXT_COLOR,
                        mb: 1
                    }}
                >
                    {title}
                </Typography>

                {/* Message */}
                <Typography 
                    variant="body1"
                    sx={{ 
                        color: '#6b7280',
                        mb: 3,
                        lineHeight: 1.6
                    }}
                >
                    {message}
                </Typography>

                {/* Action Button */}
                <Button
                    component={Link}
                    to={redirectTo}
                    variant="contained"
                    startIcon={<MdHome />}
                    sx={{
                        backgroundColor: BRAND_ACCENT,
                        '&:hover': {
                            backgroundColor: '#059669',
                        },
                        textTransform: 'none',
                        py: 1,
                        px: 3,
                        fontWeight: 600,
                        borderRadius: 2,
                    }}
                >
                    Go to Dashboard
                </Button>
            </Paper>
        </Box>
    );
};

export default StatusPage;
